import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/home/home/home.component';
import { NotFoundComponent } from './components/home/not-found/not-found.component';

const AppRoutes: Routes = [
    { path: '', component: HomeComponent },
    { path: '**', component: NotFoundComponent }
];

export const AppRouting = RouterModule.forRoot(AppRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts